var p = (o, e, t) => new Promise((s, i) => {
  var c = (r) => {
    try {
      a(t.next(r));
    } catch (n) {
      i(n);
    }
  }, C = (r) => {
    try {
      a(t.throw(r));
    } catch (n) {
      i(n);
    }
  }, a = (r) => r.done ? s(r.value) : Promise.resolve(r.value).then(c, C);
  a((t = t.apply(o, e)).next());
});
import { selfAxios as d } from "@oppein/op-utils";
function l(o) {
  return p(this, null, function* () {
    const {
      data: e
    } = yield d.post(
      "/designordercenter/productionOrder/specialApply/createCarrierChange",
      o
    );
    return e == null ? void 0 : e.data;
  });
}
export {
  l as postCreateCarrierChange
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/specialApply/createCarrierChange/post.js
// module id = 1821
// module chunks = 67